'use client';

import { createContext, useContext } from 'react';
import { useAuth } from '@/contexts/auth-context';
import { isFeatureEnabled } from '@/lib/feature-flags';

const ConversationalDesignContext = createContext(false);

/** The server supplies the deployment flag; authors need access to a supported type. */
export function StudioFeaturesProvider({ conversationalDesign, children }: {
  conversationalDesign: boolean;
  children: React.ReactNode;
}) {
  return <ConversationalDesignContext.Provider value={conversationalDesign}>{children}</ConversationalDesignContext.Provider>;
}

export function useConversationalDesignEnabled(): boolean {
  const enabled = useContext(ConversationalDesignContext);
  const { isAuthenticated, hasAnyPermission } = useAuth();
  return enabled && isAuthenticated && (
    (isFeatureEnabled('agents') && hasAnyPermission(['AIManager:ManageAgents'])) ||
    (isFeatureEnabled('workflows') && hasAnyPermission(['AIManager:ManageAgents']))
  );
}
